import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DownloadGeneralResponseModel } from '../Modelo/response/downloadResponseModel';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor(private _httpClient: HttpClient) { }

  getDownloads(): Promise<DownloadGeneralResponseModel> {
    return this._httpClient
               .get<DownloadGeneralResponseModel>(`${environment.UrlBase}${environment.endpoint.downloads}/Get`)
               .toPromise();
  }
}
